import { ComponentFactoryResolver, Directive, Input, OnInit, ViewContainerRef, SimpleChanges, OnChanges, ComponentRef, Output, EventEmitter, Inject } from '@angular/core';
import { AbstractControl, FormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { FormViewDateComponent } from './form-view-date/form-view-date.component';
import { FormViewTextComponent } from './form-view-text/form-view-text.component';
import { FormViewSelectComponent } from './form-view-select/form-view-select.component';
import { FormViewInputComponent } from './form-view-input/form-view-input.component';
import { FormViewNumberComponent } from './form-view-number/form-view-number.component';
import { DynamicFormsService } from 'src/app/services/dynamic-forms.service';
import { FormViewSearchComponent } from './form-view-search/form-view-search.component';
import { FormViewText2Component } from './form-view-text2/form-view-text2.component';
import { columnsDef } from 'src/app/interfaces/columnsDef';
import { ObjectUtil } from 'src/app/system-utils/utils/ObjectUtil';
import { FieldsProperties, UserConfigServices } from 'src/app/services/user-config.services';
import { UserAuthenticationServices } from 'src/app/services/user-authentication.services';
import { MaskEditField } from 'src/app/interfaces/user-authentication';
import { BehaviorSubject, debounceTime, distinctUntilChanged, Subject, Subscription, tap } from 'rxjs';
import { FormViewImageComponent } from './form-view-image/form-view-image.component';
import { FormViewActionComponent } from './form-view-action/form-view-action.component';
import { REGISTRY } from 'src/app/interfaces/registry-services';
import { FormViewRichTextComponent } from './form-view-rich-text/form-view-rich-text.component';
import { FormServices } from 'src/app/services/form.services';
import { FormulaTSService } from 'src/app/services/formula-ts.service';
import { LanguageService } from 'typescript';
import { LanguageServices } from 'src/app/services/LanguageServices';
import { TranslateService } from '@ngx-translate/core';



const components = {
  VARCHAR: FormViewInputComponent,
  CHAR: FormViewInputComponent,
  SELECT: FormViewSelectComponent,
  DATE: FormViewDateComponent,
  DATETIME: FormViewDateComponent,
  TEXT: FormViewTextComponent,
  TEXT2: FormViewText2Component,
  RICHTEXT: FormViewRichTextComponent,
  IMAGE: FormViewImageComponent,
  INT: FormViewNumberComponent,
  BIGINT: FormViewNumberComponent,
  DECIMAL: FormViewNumberComponent,
  FLOAT: FormViewNumberComponent,
  SMALLINT: FormViewNumberComponent,
  SHORT: FormViewNumberComponent,
  REFERENCE: FormViewSearchComponent,
  SEARCHREFERENCE: FormViewSearchComponent,
  INPUTACTION: FormViewActionComponent  
};

@Directive({
    selector: '[dynamicField]',
    standalone: false
})
export class FormViewDirective implements OnInit, OnChanges {

  @Input("config") config:columnsDef;
  @Input("group") group:UntypedFormGroup;
  @Input("row") row:Object;
  @Input("isDynamicform") isDynamicform:boolean = true;
  @Input("arrayColumnsDef") arrayColumnsDef:columnsDef[];
  @Input("entityName") entityName:string;
  @Input("entityDesc") entityDesc:string;
  @Input("canConfig") canConfig=false;
  @Input("tabindex") tabindex:number = -1;
  @Output("editEventEmmiter") editEventEmmiter = new EventEmitter();
  @Output("dataOutPut") dataOutPut = new EventEmitter();
  @Input("condition") condition;
  @Input('evento')evento;
  @Input('showBuscaDados') showBuscaDados:boolean = true;
  variables:Map<string,any> = new Map();
  changedColumns:String[]=[];
  componentEventEmmiter:EventEmitter<boolean> = new EventEmitter();
  componentEventBlurEmmiter:EventEmitter<boolean> = new EventEmitter();
  pk:Object = {};  
  configOLD:columnsDef;

  public component:ComponentRef<any>;

  private configRef:columnsDef;
  sub:Subscription;
  sub1:Subscription;
  sub2:Subscription;
  expression:string;
  
  constructor(private resolver: ComponentFactoryResolver,private container: ViewContainerRef, private dynaServices:DynamicFormsService, 
    private uas:UserAuthenticationServices, private userConfig:UserConfigServices,
    private formServices:FormServices, private fots:FormulaTSService, private ls:LanguageServices, private ts:TranslateService) { }
  
  ngOnChanges(changes: SimpleChanges): void {
      
    if ( changes.condition!= null ){
      if ( changes.condition.currentValue!= changes.condition.previousValue ){
        this.condition = changes.condition.currentValue;
        if ( this.component!= null && this.component.instance!=null){
          this.component.instance.customCondition = this.condition;
        }
      }
    }      
  }

  ngOnDestroy(){
    if (this.sub!= null ) {this.sub.unsubscribe();}
    if (this.sub1!= null ) {this.sub1.unsubscribe();}
    if (this.sub2!= null ) {this.sub2.unsubscribe();}
  }

  ngAfterViewInit(){
    if ( this.componentEventEmmiter != null){
      this.sub  = this.componentEventEmmiter.subscribe(x=>{
        this.editEventEmmiter.next(x);
      })
    }

    if ( this.componentEventBlurEmmiter!= null ){
      this.sub2  = this.componentEventBlurEmmiter.subscribe((x:FocusEvent)=>{
          // componentes NG-ZORRO podem emitir blur sem payload — proteger a leitura de .type
          if ( x != null && x.type == 'blur'){
            let ob = {}
            ob[this.config.COLUMNNAME]= this.group.get(this.config.COLUMNNAME);
            this.variables.set('evento',this.evento);
            this.fots.toMap(ob,this.variables);
            if ( this.expression != null ){
              this.fots.execute(this.expression,this.variables,this.group);
            }
          }
      });
    }

    try{
        this.applyCompanyListener(this.group.get("CODECOMPANY").value,this.userConfig.fieldProperties,this.group,this.config,this.component,this.configOLD);
    }catch(Ex){}
  }
 
  
  translate(){
    let entity = this.entityName;
    if ( this.entityName == null){
        entity='filter';
    }

    if ( this.config != null  ){
       this.config.COLUMNDESC =  this.ls.instant(entity.toUpperCase()+'.'+this.config.COLUMNNAME.toUpperCase());
       this.config.PLACEHOLDER =  this.ls.instant(entity.toUpperCase()+'.'+this.config.COLUMNNAME.toUpperCase());
    }

    if ( this.configRef! = null ){
      this.configRef.COLUMNDESC =  this.ls.instant(entity.toUpperCase()+'.'+this.configRef.COLUMNNAME.toUpperCase());
      this.configRef.PLACEHOLDER =  this.ls.instant(entity.toUpperCase()+'.'+this.configRef.COLUMNNAME.toUpperCase())
    }
  }

  ngOnInit() {

    if ( this.config == null){
      return;
    }

    this.translate();

    this.ts.onLangChange.subscribe(() => {
      this.translate();
    });


    if ( this.group  != null ){
      this.fots.toMap(this.group,this.variables); 
    }
    
    this.configOLD = JSON.parse(JSON.stringify(this.config));
    
    if ( this.group.contains('CODECOMPANY')){

      this.sub1 = this.group.get("CODECOMPANY").valueChanges.pipe(
          //debounceTime(400),
          distinctUntilChanged(),
          tap(change=>{
            this.applyCompanyListener(change,this.userConfig.fieldProperties,this.group,this.config,this.component,this.configOLD);
            
      })).subscribe();
    }

    if ( this.config.DATATYPE == "TEXT" && this.isDynamicform ){
        this.config.DATATYPE = "TEXT2";
    }

    if ( this.config.DATATYPE == "VARCHAR" && ( this.config.COLSIZE == -1 || this.config.COLSIZE >= 4000 )  && !this.isDynamicform){
      if ( this.config.RICHTEXTCOL!=null && this.config.RICHTEXTCOL=="S"){
        this.config.DATATYPE = "RICHTEXT";
        this.config.ISREADONLY = 0;
        this.configOLD.ISREADONLY = 0;
      }else{
        this.config.DATATYPE = "TEXT";
      }
    }

    if ( this.config.DATATYPE == "VARCHAR" && ( this.config.COLSIZE == -1 || this.config.COLSIZE >= 4000 ) && this.isDynamicform){
      this.config.DATATYPE = "TEXT2";
    }
    
    if ( (this.config.DATATYPE == "VARCHAR" || this.config.DATATYPE == "INT") && this.dynaServices.isSelect(this.config).length > 0 ){
        this.config.DATATYPE = "SELECT";
    }
    
    if ( this.config.VALIDATIONERROR != null){
      try{  
        let validation = JSON.parse(this.config.VALIDATIONERROR);
        let type = validation['type'];
        
        if ( type == 'action'){
          this.config.DATATYPE = "INPUTACTION";
        }
        
        if ( type == 'validationInteger' && (this.config.DATATYPE=='INT' || this.config.DATATYPE=='BIGINT' || this.config.DATATYPE=='DECIMAL' || this.config.DATATYPE=='FLOAT' || this.config.DATATYPE=='SMALLINT' || this.config.DATATYPE=='SHORT') ){
            let options = validation['options'];
            if ( options['minimum']){
              this.group.get(this.config.COLUMNNAME).addValidators(Validators.min(options['minimum']));
            }
            if ( options['maximum']){
              this.group.get(this.config.COLUMNNAME).addValidators(Validators.max(options['maximum']));
            }
            
        }
        
        
      }catch(Exception){}
    }

    this.configRef = null;

    if ( this.config.ISFK == 1 && this.config.REFERENCES!= null && this.config.DATATYPE!="SEARCHREFERENCE"){
      this.config.REFERENCES.forEach(ref=>{
        let arrayLen = this.arrayColumnsDef.filter(value=> value.COLUMNNAME.split("->")[0] == ref.CONSTRAINT_NAME && value.COLUMNNAME.indexOf("->") > -1
        && JSON.parse(value.VALIDATIONERROR)['ColumnName']== ref.CONSTRAINT_COLUMN );
        if ( arrayLen.length > 0 ){
          this.configRef = arrayLen[0];
          this.config.DATATYPE = "REFERENCE";
        }
      })
    }
  
    if ( this.config.ISFK == 1 && this.config.REFERENCES!= null && this.config.DATATYPE=="SEARCHREFERENCE"){
        this.configRef = this.arrayColumnsDef.filter(value=> value.COLUMNNAME.startsWith(this.config.COLUMNNAME) )[0];  
    }


    if ( this.config.ISREADONLY == 1){
      this.group.get(this.config.COLUMNNAME).disable();
    }else{
      this.group.get(this.config.COLUMNNAME).enable();
    }

    if ( this.config.COLUMNNAME.startsWith("FK_") && this.config.COLUMNNAME.indexOf("->") == 0){
      //this.group.get(this.config.COLUMNNAME).disable();
    }

    if ( this.config.DEFAULTVALUE != null ){
        this.group.get(this.config.COLUMNNAME).setValue(this.config.DEFAULTVALUE,{
          emitEvent: false
        });
    }
    
    if ( ObjectUtil.isNotEmpty(this.row )){
      this.arrayColumnsDef.filter(x=>{return x.ISPK === 1}).forEach(y=>{
        this.pk[y.COLUMNNAME] = this.row[y.COLUMNNAME];
      });
    }
    
    const component = components[this.config.DATATYPE];
    if ( component == null ){
        console.error('Erro de Configuração de Componente');
        return;
    }
    const factory = this.resolver.resolveComponentFactory<any>(component);
    this.component = this.container.createComponent(factory); 
    this.component.instance.config = this.config;
    this.component.instance.group = this.group;
    this.component.instance.canConfig = this.canConfig;
    this.component.instance.row = this.row;
    this.component.instance.entityName = this.entityName;
    this.component.instance.entityDesc = this.entityDesc;
    this.component.instance.showBuscaDados = this.showBuscaDados;

    if ( this.uas.user.maskEditField != null){
      let maskEditField:MaskEditField = this.uas.user.maskEditField.find(data=>data.entityName == this.entityName && data.columnName == this.config.COLUMNNAME);
      if ( maskEditField != null ){
        this.component.instance.maskEditField = maskEditField;
      }
    }
    
    if ( this.config.DATATYPE == "TEXT" ){
      this.component.instance.pk = this.pk;
    }

    if ( this.tabindex > -1 ){
      this.component.instance.tabindex = String(this.tabindex);
    }
    
    this.componentEventEmmiter = this.component.instance.editEvent;
    this.componentEventBlurEmmiter = this.component.instance.blurEvent;
    
    if ( this.config.DATATYPE == "REFERENCE" || this.config.DATATYPE=="SEARCHREFERENCE"){
    
      if ( this.configRef != null ){
        this.component.instance.configRef = this.configRef;
        this.component.instance.entityName = JSON.parse(this.configRef.VALIDATIONERROR)['RefName'];
        this.component.instance.entityNameDesc = JSON.parse(this.configRef.VALIDATIONERROR)['RefDesc'];
        this.component.instance.arrayColumnsDef = this.arrayColumnsDef;
        this.component.instance.customCondition = this.condition;
        this.component.instance.showBuscaDados = this.showBuscaDados;
      }else{
        this.component.instance.configRef = this.config;
        this.component.instance.entityName = JSON.parse(this.config.VALIDATIONERROR)['RefName'];
        this.component.instance.entityNameDesc = JSON.parse(this.config.VALIDATIONERROR)['RefDesc'];
        this.component.instance.arrayColumnsDef = this.arrayColumnsDef;
        this.component.instance.customCondition = this.condition;
        this.component.instance.showBuscaDados = this.showBuscaDados;
      }
    }
    
    if ( this.config.DATATYPE=="IMAGE"){
      this.component.instance.arrayColumnsDef  = this.arrayColumnsDef;
    }

    if ( this.config.DATATYPE =="INPUTACTION"){
      let validation = JSON.parse(this.config.VALIDATIONERROR);
      this.component.instance.toolTip =  validation['toolTip'];
      this.component.instance.action_icon =  validation['actionIcon'];      
      this.component.instance.widthPopUp  = validation['widthPopUp'];      
      
      if ( validation['component']!= null ){
        const component = REGISTRY.get(validation['component']);
        this.component.instance.validation = validation;
        this.component.instance.component =  component;
        this.component.instance.disableAction = false;
      }
    }  
  }

  applyCompanyListener(company, fieldProperties:FieldsProperties[], group:UntypedFormGroup, config:columnsDef, component:any, configOld:columnsDef ){
    
    var codeCompanyChange:string = company;
    
    this.changedColumns.forEach((columnName:String)=>{
      this.applyConfigDefault(group.get(columnName.toString()),columnName.toString(), this.configOLD, this.component);
    });
    this.changedColumns = [];

    if ( ObjectUtil.isNotEmpty(codeCompanyChange)){ 
      if ( fieldProperties && this.entityName != null ){
        let index = fieldProperties.findIndex(d=>d.codecompany == codeCompanyChange && d.name!= null && d.name.split('_')[1].toUpperCase()==this.entityName.toUpperCase());    
        if ( index > -1 ){
              fieldProperties.filter(d=>d.codecompany == codeCompanyChange && d.name.split('_')[1].toUpperCase()==this.entityName.toUpperCase()).forEach( properties=>{
              let arrayProp = properties.name.trim().split('_');
              let columnName = '';
              arrayProp.forEach((valur,index)=>{
                  if ( index >1 ){
                    columnName+=(index>2?'_':'')+valur;
                  }
              });

              try{
                  let indexKey = Object.keys(group.controls).findIndex(d=>d.toUpperCase().trim() == columnName.toUpperCase().trim());
                  if ( indexKey >-1){
                    this.changedColumns.push(columnName);
                    this.applyConfig(group.get(columnName),properties,columnName, config, component);
                    return;
                  }
                  
              }catch(exception){
                  
              }
          })
        }
      }
    }            
   }

   applyConfig(control: AbstractControl, properties: FieldsProperties, columnName:string, config:columnsDef, component) {
    
    if ( config.COLUMNNAME == columnName) {
        if ( properties.preference.expression != null ){
          this.expression = properties.preference.expression;
        }

        if ( properties.preference.toolTiptext != null ){
          this.component.instance.toolTipText = properties.preference.toolTiptext;
        }

        if ( properties.preference.decimal!= null || properties.preference.decimalText != null){
          if ( this.uas.user.maskEditField != null){
            let maskEditField:MaskEditField = this.uas.user.maskEditField.find(data=>data.entityName == this.entityName && data.columnName == this.config.COLUMNNAME);
            if ( maskEditField != null ){
              let decimal = properties.preference.decimal;
              if ( properties.preference.decimalText != null ){
                  decimal = Number(this.fots.calculate(properties.preference.decimalText, this.variables));
              }
              maskEditField.mask =  "separator."+decimal; 
              this.component.instance.maskEditField = maskEditField;
            }
          }
        }
        
        if ( properties.preference.description!= null || properties.preference.descriptionText != null ) {         
            component.instance.config.COLUMNDESCOLD = component.instance.config.COLUMNDESC;
            component.instance.config.PLACEHOLDEROLD = component.instance.config.PLACEHOLDER;
            let desc = properties.preference.description;

            if ( properties.preference.descriptionText != null ){
                desc = this.fots.calculate(properties.preference.descriptionText,this.variables);
            }

            component.instance.config.COLUMNDESC = desc;
            component.instance.config.PLACEHOLDER = desc;
        }else{
            component.instance.config.COLUMNDESC = component.instance.config.COLUMNDESCOLD;
            component.instance.config.PLACEHOLDER = component.instance.config.PLACEHOLDEROLD;
        }

        if  ( properties.preference.readonlyText!= null ){
          let readOnly = this.fots.calculate(properties.preference.readonlyText,this.variables);
          if ( readOnly ){
            control.disable();
          }else{
            control.enable();
          }
        }else{
          if ( properties.preference.readonly ){
            control.disable();
          }else{
            control.enable();
          }
        }
        
        if ( properties.preference.requiredText != null ){
          let required = this.fots.calculate(properties.preference.requiredText,this.variables);
          if ( required ){
            control.addValidators(Validators.required);
          }else{
            control.removeValidators(Validators.required);
          }
        }else{
          if ( properties.preference.required ){
            control.addValidators(Validators.required);
          }else{
            control.removeValidators(Validators.required);
          }
        }
        
        if ( properties.preference.maxLengthText != null ){
            let maxLength = this.fots.calculate(properties.preference.maxLengthText,this.variables);
            if ( maxLength != null  && maxLength >0 ){
              control.addValidators(Validators.maxLength(maxLength));  
            }
        }else{
          if ( properties.preference.maxLength!= null && properties.preference.maxLength > 0 ){
            control.addValidators(Validators.maxLength(properties.preference.maxLength));
          }
        }
        
        if ( properties.preference.minLengthText != null ){
          let minLength = this.fots.calculate(properties.preference.minLengthText,this.variables);
          if ( minLength != null  && minLength >0 ){
            control.addValidators(Validators.minLength(minLength));  
          }
        }else{
         if ( properties.preference.minLength!= null && properties.preference.minLength > 0 ){
           control.addValidators(Validators.minLength(properties.preference.minLength));
         }
        }
        
        if ( properties.preference.defaultValueText != null ){
          let defaultValue = this.fots.calculate(properties.preference.defaultValueText,this.variables);
          if ( defaultValue!= null ){
            control.setValue(defaultValue,{
              emitEvent: false
            });
          }
        }else{
          if ( properties.preference.defaultValue != null ){
            control.setValue(properties.preference.defaultValue,{
              emitEvent: false
            });
          }
        }
        
        control.updateValueAndValidity();
      }
  }

  applyConfigDefault(control: AbstractControl,columnName:string, configOLD:columnsDef, component:any){
    
    if ( columnName.toUpperCase() == configOLD.COLUMNNAME.toUpperCase()) {
      if ( configOLD.COLUMNDESC ) {
        component.instance.config.COLUMNDESC = configOLD.COLUMNDESC;
        component.instance.config.PLACEHOLDER = configOLD.PLACEHOLDER;
      }

      this.component.instance.toolTipText = null;
      
      this.expression = null;
      
      if ( configOLD.ISREADONLY ){
        control.disable();
      }else{
        control.enable();
      }
      if ( configOLD.ISREQUIRED ){
        control.addValidators(Validators.required);
      }else{
        control.removeValidators(Validators.required);
      }

      if ( configOLD.COLSIZE!= null && configOLD.COLSIZE > 0 ){
          control.addValidators(Validators.maxLength(configOLD.COLSIZE));
      }

      control.addValidators(Validators.minLength(0));
      
      if ( configOLD.ISFK !=1 && (configOLD.REFERENCES==null || configOLD.REFERENCES.length == 0 )){
        control.setValue(null,{
          emitEvent: false
        });        
      }
    }
  }



}
